// 该组件无设计图，后续若有特殊细节要求，再做详细修改
var transferData = {
  name: 'transfer',
  data: [{// 添加需要修改的变量
  }]
};
export default transferData;